import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, role }) => {
  const authToken = sessionStorage.getItem('authToken');
  const loginTime = sessionStorage.getItem('loginTime');
  const userRole = sessionStorage.getItem('userRole'); // Get user role

  if (!authToken || !loginTime || !userRole) {
    return <Navigate to="/login" />;
  }

  // Check if the session has expired (1 week)
  const currentTime = new Date().getTime();
  const loginTimeInMs = new Date(loginTime).getTime();
  const sessionDuration = currentTime - loginTimeInMs;

  if (sessionDuration > 604800000) {  // 1 week = 604800000 ms
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('loginTime');
    sessionStorage.removeItem('userRole');
    return <Navigate to="/login" />;
  }

  // Role-based protection
  if (role) {
    const allowedRoles = Array.isArray(role) ? role : [role];
    
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
